export const REGIONS_REQUEST = "REGIONS_REQUEST";
export const REGIONS_SUCCESS = "REGIONS_SUCCESS";
export const REGIONS_ERROR = "REGIONS_ERROR";